var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg095950C54E0E0Afaabaedc26B44Ee1B6Ecffa557(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 43.1256 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg095950C54E0E0Afaabaedc26B44Ee1B6Ecffa557);
export default __webpack_public_path__ + "static/media/095950c54e0e0afaabaedc26b44ee1b6ecffa557.2ae53400ddfd85ea687b8044c36f1160.svg";
export { ForwardRef as ReactComponent };